import React from 'react';
import ManageUserEditSection from '../components/Users/Edit/ManageUserEditSection';

const ManageUserEdit = () => {
  return (
    <ManageUserEditSection />
  )
}

export default ManageUserEdit